import sdk from '@/sdk';
import * as store from '@/store';

import toast, {ToastType} from '@/components/Toast';

export const addToCommonDoc = async (docGuid: string) => {
    const repository = store.getData(store.KEYS.CUR_REPOSITORY);
    const ksServer = await sdk.getKsServer(repository);
    return ksServer.addToCommonDoc(docGuid, repository.repositoryGuid).catch(err => {
        console.error(err);

        toast({
            content: '添加失败',
            type: ToastType.Error,
        });
    });
};

export const removeCommonDoc = async (docGuid: string) => {
    const repository = store.getData(store.KEYS.CUR_REPOSITORY);
    const ksServer = await sdk.getKsServer(repository);
    return ksServer.removeCommonDoc(docGuid, repository.repositoryGuid).catch(err => {
        console.error(err);

        toast({
            content: '移出失败',
            type: ToastType.Error,
        });
    });
};
